var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95858 0.71189L4.93199 3.32609C5.17872 3.62203 5.12933 4.06601 4.93199 4.31256L3.5999 5.69361C2.9585 6.23623 7.20135 10.5273 7.79338 9.93539L9.12547 8.60361C9.42149 8.30766 9.86557 8.30766 10.1616 8.55423L12.7271 10.5272C13.0725 10.7738 13.0725 11.1191 12.8257 11.415L11.247 12.9933C9.42158 14.769 4.98146 11.415 3.59997 10.0339C2.21859 8.5542 -1.28441 4.06573 0.491673 2.24049L2.07038 0.662157C2.31711 0.415482 2.76107 0.464863 2.95842 0.711538L2.95858 0.71189Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6ada14b0246d3552488b0778cb040a5a.svg";
export { ForwardRef as ReactComponent };